import React, { Component } from "react";
import lineImg from "../images/line.webp";
import $ from "jquery";
import { Link } from "react-router-dom";
import { apiCallingPost } from "../services";
import noOutletImg from "../images/no-outlets-message-img.png";
import searchLoading from "../images/loading.gif";
import ImportantNotice from "./important-notice";
const GoogleMap = React.lazy(() => import("./GoogleMapHomeLeaflet"));
const Servicestation = React.lazy(() => import("./service-station"));
let currentLocationFlag = false;
let searchValueSet = "";
var searchCategorySet, searchServiceSet;
let categoryFilter = [];
let serviceFilter = [];
let searchCategoryList = [];
let searchServiceList = [];

// let valueFromSession=[(window.sessionStorage.getItem("searchObjArray"))
class SearchStore extends Component {
	constructor(props) {
		super(props);
		this.state = {
			mapKey: new Date(),
			isData: false,
			searchType: "Advanced",
			stateList: window.sessionStorage.getItem("searchObjArray")
				? JSON.parse(window.sessionStorage.getItem("searchObjArray"))[11].stateList
					? JSON.parse(window.sessionStorage.getItem("searchObjArray"))[11].stateList
					: []
				: [],
			cityList: window.sessionStorage.getItem("searchObjArray")
				? JSON.parse(window.sessionStorage.getItem("searchObjArray"))[12].cityList
					? JSON.parse(window.sessionStorage.getItem("searchObjArray"))[12].cityList
					: []
				: [],
			dataFromCity: [],
			dataFromLocation: [],
			stateValue: this.props.url_location.search.includes('search=') ? "" : window.sessionStorage.getItem("searchObjArray") ? "" : "Maharashtra",
			city: this.props.url_location.search.includes('search=') ? "" : window.sessionStorage.getItem("searchObjArray") ? "" : "Mumbai",
			location: "",
			locationList: window.sessionStorage.getItem("searchObjArray")
				? JSON.parse(window.sessionStorage.getItem("searchObjArray"))[10].locationList
					? JSON.parse(window.sessionStorage.getItem("searchObjArray"))[10].locationList
					: []
				: [],
			radius: "",
			outletType: "Both",
			radiusList: ["3", "5", "7", "9", "11", "13"],
			// categoryList: ["ATM", "Branch", "Loan Centre", "Rural Lending Office", "CDM"],
			// categoryList: { ATM: false, Branch: false, 'Loan Centre': false, 'Rural Lending Office': false, CDM: false  },
			categoryList: JSON.parse(window.sessionStorage?.getItem("categoryChecked"))?.length > 0 ? JSON.parse(window.sessionStorage?.getItem("categoryChecked")) :[{ name: "ATM", status: false }, { name: "Branch", status: false }, { name: "Loan Centre", status: false }, { name: "Rural Lending Office", status: false }, { name: "CDM", status: false }],
			servicesList: JSON.parse(window.sessionStorage?.getItem("serviceChecked"))?.length > 0 ? JSON.parse(window.sessionStorage?.getItem("serviceChecked")) : [],
			searchAnything: "",
			offset: "0",
			pagesize: "3",
			activePage: 1,
			searchCategory: [],
			searchService: [],
			centersData: [],
			centersTotalCount: 0,
			itemsCountPerPage: 3,
			searchFlag: false,
			searchUpdateKey: 0,
			searchObjArray: [],
			stateOptionDefault: "State",
			cityTextDefault: "Please select city",
			locationTextDefault: "Please select city first",
			radiusOptionDefault: "Please enter locality first",
			searchClickFlag: false,
		};
		this.getSearchResult = this.getSearchResult.bind(this);
		this.changeCategory = this.changeCategory.bind(this);
		this.changeService = this.changeService.bind(this);
		this.handlePageChange = this.handlePageChange.bind(this);
	}

	async componentDidMount() {
		for (const category of this.state.categoryList) {
			if (category.status === true) {
				searchCategoryList.push(category.name)
			}
		}
		this.setState({
			searchCategory: searchCategoryList ,
		});
		for (const service of this.state.servicesList) {
			if (service.status === true) {
				searchServiceList.push(service.name)
			}
		}
		this.setState({
			searchService: searchServiceList ,
		});
		let pathname = this.props.pathname;
		const pathnameSplit = pathname.split("/");
		let currentUrlState = "";
		let currentUrlCity = "";
		// this.state({
		//   searchAnything : (this.props.url_location.search.includes("type=") ? "" : (this.props.url_location.search ? this.props.url_location.search.replaceAll("%20+", ",").replaceAll("+", " ").replaceAll("%20", " ").replaceAll("%2C", ",").replaceAll("?search=", "") : (window.sessionStorage.getItem("searchObjArray") && JSON.parse(window.sessionStorage.getItem("searchObjArray"))[8].searchValueSet) ? JSON.parse(window.sessionStorage.getItem("searchObjArray"))[8].searchValueSet : ""))
		// })
		$("html, body").animate(
			{
				scrollTop: $("html, body").offset().top,
			},
			"slow"
		);
		$("#location, #radius").attr("disabled", false);
		setTimeout(() => {
			if ($("#searchAnything").val()) {
				$("#state, #location, #radius").attr("disabled", true);
				this.setState({ stateOptionDefault: "Please remove search nearby text first" });
			}
		}, 6000);

		if (window.sessionStorage.getItem("searchObjArray") && JSON.parse(window.sessionStorage.getItem("searchObjArray"))[2].locationSet != "") {
			this.setState({ radiusOptionDefault: "Please select radius" });
		}
		if (this.state.city) {
			$("#location").attr("disabled", false);
			this.setState({ locationTextDefault: "Type your locality" });
		}
		await this.getOnLoadCityData(this.state.city, this.state.stateValue);
		if ((this.props.url_location.search) && (!this.props.url_location.search.includes('page='))) {
			let searchParams = new URLSearchParams(this.props.url_location.search);
			let typeValue = searchParams.get("type") ? searchParams.get("type").replaceAll("-", " ") : "";
			if (searchParams.has("type")) {
				if (typeValue.includes("centers")) {
					typeValue = typeValue.replace("centers", "centre");
				}
				categoryFilter = this.state.categoryList.filter((obj) => obj.name.toLowerCase() === typeValue.toLowerCase()).map(obj => obj.name);
				serviceFilter = this.state.servicesList.filter((obj) => typeValue.includes(obj.name.toLowerCase())).map((item) => item.name);
				if (categoryFilter.length == 0 && serviceFilter.length == 0) {
					serviceFilter = ["Banking"];
					if (typeValue.includes("overseas presence")) {
						//window.location.href = "/axis-bank-overseas-branches";
					}
				}
				this.setState({
					searchAnything: "",
					stateValue: "Maharashtra",
					city: "Mumbai",
					// searchCategory: categoryFilter,
					// searchService: serviceFilter
				});
			} else if (searchParams.get("state_name") || searchParams.get("city_name") || searchParams.get("locality_name")) {
				let joinedParams = [searchParams.get("locality_name"), searchParams.get("city_name"), searchParams.get("state_name")].filter(Boolean).join(", ");
				this.setState({
					searchAnything: joinedParams,
				});
			} else {
				searchParams.delete("_ga");
				searchParams.delete("page");
				const paramsObject = {};
				let getParams = [];
				for (const [key, value] of searchParams) {
					paramsObject[key] = value;
					getParams.push(value);
				}
				let joinedParams = getParams.join(", ");
				this.setState({
					searchAnything: joinedParams,
				});
			}
			this.getSearchResult();
		} else if ((!this.props.url_location.search) || (this.props.url_location.search.includes('page='))) {
			let state_name = this.props.paramsUrl.State?.replaceAll("-", " ").split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ") || "";
			let city_name = this.props.paramsUrl.City?.replaceAll("--", "  ").replaceAll("-", " ").split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
			city_name = city_name?.split("&").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join("&") || "";
			if (this.props.paramsUrl.State && !this.props.paramsUrl.City) {
				this.setState({
					stateValue: state_name,
					city: "",
				});
			} else if (this.props.paramsUrl.State && this.props.paramsUrl.City && !this.props.paramsUrl.Location) {
				this.setState({
					stateValue: state_name,
					city: city_name,
				});
			} else if (this.props.paramsUrl.State && this.props.paramsUrl.City && this.props.paramsUrl.Location) {
				this.setState({
					stateValue: state_name,
					city: city_name,
					location: this.props.paramsUrl.Location.replaceAll("-", " "),
				});
			}
			this.getSearchResult();
		}
		this.getOnLoadCityData("", "");
	}

	changeState = (e) => {
		this.setState({
			stateValue: e,
			city: "",
			searchAnything: "",
			location: "",
			locationTextDefault: "Please select city first",
		});
		searchValueSet = "";
		let stateCityList = [];
		let filterArray = this.state.dataFromCity.filter((item) => {
			if (item.state === e) {
				stateCityList.push({ city: item.city, state: e });
			}
		});
		this.setState({
			cityList: stateCityList,
		});
		$("#location").attr("disabled", true);
	};

	changeCity = (e) => {
		this.setState({
			city: e,
		});
		if (e !== "") {
			$("#location").attr("disabled", false);
			this.setState({
				locationTextDefault: "Type your locality",
			});
			let CityLocationList = [];
			this.state.dataFromLocation.filter((item) => {
				if (item.city === e) {
					CityLocationList.push({ state: item.state, city: e, location: item.location });
				}
			});
			this.setState({
				locationList: CityLocationList,
			});
		} else {
			$("#location").val("");
			$("#location").attr("disabled", true);
			$("#radius").attr("disabled", true);
			this.setState({
				location: "",
				radius: "",
				locationTextDefault: "Please select city first",
			});
		}
	};

	changeLocality = (e) => {
		this.setState(
			{
				location: e,
			},
			() => {
				if (this.state.location !== "") {
					$("#radius").removeAttr("disabled");
					this.setState({
						radiusOptionDefault: "Please select radius",
					});
				} else {
					$("#radius").attr("disabled", true);
					this.setState({
						radius: "",
						radiusOptionDefault: "Please enter locality first",
					});
				}
			}
		);
	};

	searchByAnything = (e) => {
		$("#SearchByGivenAddress").hide();
		this.setState({
			searchAnything: e,
			stateValue: "",
			city: "",
			location: "",
			radius: "",
			cityTextDefault: "Please select city",
			locationTextDefault: "Please select city first",
			radiusOptionDefault: "Please enter locality first",
		});
		if (e != "") {
			$("#state, #city, #location, #radius").attr("disabled", true);
			this.setState({
				stateOptionDefault: "Please remove search nearby text first",
			});
		} else {
			$("#state").attr("disabled", false);
			this.setState({
				stateOptionDefault: "All",
			});
		}
	};

	getOnLoadCityData = (city, stateValue) => {
		return new Promise((resolve, reject) => {
			const apiData = {
				functionName: "getHomePageData",
				searchType: this.state.searchType,
				location: this.state.location,
				cityAdvanceSearch: city,
				state: stateValue,
				outletType: this.state.outletType,
			};
			//console.log("apiData----------", apiData);
			apiCallingPost(apiData).then((data) => {
				if (data.data.success === "1") {
					let stateCityList = [];
					let stateCityLocationList = [];
					this.setState({
						stateList: data.data.state,
						cityList: data.data.city,
						//locationList: data.data.location
					});
					if(JSON.parse(window.sessionStorage?.getItem("serviceChecked"))?.length == undefined ) {
						// this.setState({
						// 	servicesList: data.data.services,
						// })
						const serviceFilterStatus = data.data.services.map(service => ({ ...service, status: false }));
						this.setState({
							servicesList: serviceFilterStatus,
						})
						window.sessionStorage.setItem("servicesList", JSON.stringify(serviceFilterStatus));
					}
					else {
						this.setState({
							servicesList: JSON.parse(window.sessionStorage.getItem("serviceChecked")),
						})
					}
					this.setState(
						{
							dataFromCity: data.data.city,
							stateList: data.data.state,
							dataFromLocation: data.data.location,
						},
						() => {
							if (this.state.dataFromCity.length > 0) {
								let filterArray = this.state.dataFromCity.filter((item) => {
									if (item.state === this.state.stateValue) {
										stateCityList.push({
											city: item.city,
											state: item.state,
										});
									}
									this.setState({
										cityList: stateCityList,
									});
								});
								this.changeCity(this.state.city);
							}
						}
					);
					resolve(true);
				}
			});
			// this.getOnLoadCityData()
		});
	};

	getSearchResult = () => {
		// console.log("this.state.offset----", this.state.offset);
		var offset = this.state.offset;
		var activePage = this.state.activePage;
		searchServiceSet = [];
		if (window.sessionStorage.getItem("searchObjArray")) {
			currentLocationFlag = Object.values(JSON.parse(window.sessionStorage.getItem("searchObjArray")))[9].currentLocationFlagSetValue;
			offset = Object.values(JSON.parse(window.sessionStorage.getItem("searchObjArray")))[6].offsetSet;
			activePage = Object.values(JSON.parse(window.sessionStorage.getItem("searchObjArray")))[7].activePageSet;
			searchValueSet =
				(Object.keys(JSON.parse(window.sessionStorage.getItem("searchObjArray"))[8])
					.toString()
					.indexOf("searchValueSet") ==
					"-1") ==
					false
					? JSON.parse(window.sessionStorage.getItem("searchObjArray"))[8].searchValueSet
					: "";
			searchCategorySet =
				(Object.keys(JSON.parse(window.sessionStorage.getItem("searchObjArray"))[4])
					.toString()
					.indexOf("searchCategorySet") ==
					"-1") ==
					false
					? JSON.parse(window.sessionStorage.getItem("searchObjArray"))[4].searchCategorySet
					: "";
			searchServiceSet =
				(Object.keys(JSON.parse(window.sessionStorage.getItem("searchObjArray"))[5])
					.toString()
					.indexOf("searchServiceSet") ==
					"-1") ==
					false
					? JSON.parse(window.sessionStorage.getItem("searchObjArray"))[5].searchServiceSet
					: "";
			this.setState(
				{
					searchCategory: searchCategorySet,
					searchService: searchServiceSet,
					servicesList: JSON.parse(window.sessionStorage.getItem("servicesList")),
				},
				() => {
					searchServiceSet.forEach((data, i) => {
						$("#" + "check" + data.replaceAll(/ +/g, "")).prop("checked", true);
					});
				}
			);
			if (searchValueSet != "") {
				this.setState({
					stateValue: "",
					city: "",
					location: "",
					radius: "",
				});
			} else {
				var stateValueForSession =
					(Object.keys(JSON.parse(window.sessionStorage.getItem("searchObjArray"))[0])
						.toString()
						.indexOf("stateValueSet") ==
						"-1") ==
						false
						? JSON.parse(window.sessionStorage.getItem("searchObjArray"))[0].stateValueSet
						: "";
				var cityValueForSession =
					(Object.keys(JSON.parse(window.sessionStorage.getItem("searchObjArray"))[1])
						.toString()
						.indexOf("citySet") ==
						"-1") ==
						false
						? JSON.parse(window.sessionStorage.getItem("searchObjArray"))[1].citySet
						: "";
				var locationSetValue =
					(Object.keys(JSON.parse(window.sessionStorage.getItem("searchObjArray"))[2])
						.toString()
						.indexOf("locationSet") ==
						"-1") ==
						false
						? JSON.parse(window.sessionStorage.getItem("searchObjArray"))[2].locationSet
						: "";
				var radiusSetValue =
					(Object.keys(JSON.parse(window.sessionStorage.getItem("searchObjArray"))[3])
						.toString()
						.indexOf("radiusSet") ==
						"-1") ==
						false
						? JSON.parse(window.sessionStorage.getItem("searchObjArray"))[3].radiusSet
						: "";
				this.setState({
					stateValue: stateValueForSession,
					city: cityValueForSession,
					radius: radiusSetValue,
					location: locationSetValue,
				});
			}
			if (searchCategorySet) {
				{
					searchCategorySet.map((data, i) => $("#" + "check" + data.replaceAll(/ +/g, "")).prop("checked", true));
				}
			}
		}
		let pagesize = this.state.pagesize;
		this.centersData = [];
		const apiData = {
			functionName: "getHomeSearchResultElastic",
			city: !cityValueForSession ? this.state.city : cityValueForSession,
			searchType: this.state.searchType,
			state: !stateValueForSession ? this.state.stateValue : stateValueForSession,
			cityAdvanceSearch: !cityValueForSession ? this.state.city : cityValueForSession,
			location: !locationSetValue ? this.state.location : locationSetValue,
			radius: !radiusSetValue ? this.state.radius : radiusSetValue,
			outletType: this.state.outletType,
			searchCategory: this.state.searchCategory.length != 0 ? this.state.searchCategory : categoryFilter,
			searchService: this.state.searchService.length != 0 ? this.state.searchService : serviceFilter,
			search: !searchValueSet ? (typeof this.state.searchAnything === "undefined" ? "" : this.state.searchAnything.toString()) : searchValueSet.toString(),
			offSet: offset,
			pagesize: pagesize,
		};
		// const apiData = {
		//   functionName: "getHomeSearchResult",
		//   city: !cityValueForSession ? this.state.city : cityValueForSession,
		//   searchType: this.state.searchType,
		//   state: !stateValueForSession ? this.state.stateValue : stateValueForSession,
		//   cityAdvanceSearch: !cityValueForSession ? this.state.city : cityValueForSession,
		//   location: !locationSetValue ? this.state.location : locationSetValue,
		//   radius: !radiusSetValue ? this.state.radius : radiusSetValue,
		//   outletType: this.state.outletType,
		//   searchCategory: this.state.searchClickFlag == true ? this.state.searchCategory : categoryFilter,
		//   searchService: this.state.searchClickFlag == true ? this.state.searchService : serviceFilter,
		//   search: (!searchValueSet ? (typeof this.state.searchAnything === "undefined" ? "" : this.state.searchAnything.toString()) : searchValueSet.toString()),
		//   offSet: offset,
		//   pagesize: pagesize
		// };
		   //console.log("apiData-111-----", apiData);
		apiCallingPost(apiData).then((data) => {
			// console.log("4-- data------", data.data);
			if (data.data.success === "1") {
				this.setState(
					{
						isData: true,
						mapKey: new Date(),
						centersData: data.data.dealerData,
						centersTotalCount: data.data.totalCount,
						// searchFlag: true,
						searchClickFlag: false,
						searchUpdateKey: this.state.searchUpdateKey + 1,
						offset: offset,
						pagesize: pagesize,
						activePage: activePage,
					},
					() => {
						window.sessionStorage.removeItem("searchObjArray");
						searchValueSet = "";
						if (data.data.dealerData.length > 0 && sessionStorage.getItem("fromSearch")) {
							// setTimeout(() => {
							$("html, body").animate({
								scrollTop: $("#service-station").offset().top - 70,
							});
							sessionStorage.removeItem("fromSearch")
							//}, 4000);
						}
					}
				);
			} else {
				this.setState({
					centersData: [],
					centersTotalCount: 0,
					searchFlag: false,
					searchClickFlag: false,
					searchUpdateKey: this.state.searchUpdateKey + 1,
				});
			}
			window.sessionStorage.removeItem("categoryChecked");
		});
	};
	changeCategory = (e, name) => {
		// this.setState((prevProps) => {
		// 	categoryList: prevProps.categoryList.map((data) => {
		// 		console
		// 	})
		// });
		this.setState(prevState => ({
			categoryList: prevState.categoryList.map((obj) => {
				if (obj.name === name) {
					return {
						...obj,
						status: !obj.status
					}
				}
				return obj
			})
		}), () => {
			window.sessionStorage.setItem("categoryChecked", JSON.stringify(this.state.categoryList))
		})
	};
	changeService = (e, name) => {
		// let serviceChecked = this.state.searchService;
		// const findIdx = serviceChecked.indexOf(e.target.value);
		// if (findIdx > -1) {
		// 	serviceChecked.splice(findIdx, 1);
		// } else {
		// 	serviceChecked.push(e.target.value);
		// }
		// this.setState({ searchService: serviceChecked });

		this.setState(prevState => ({
			servicesList: prevState.servicesList.map((obj) => {
				if (obj.name === name) {
					return {
						...obj,
						status: !obj.status
					}
					//console.log("obj---", obj);
				}
				return obj
			})
		}), () => {
			//console.log("JSON.stringify(this.state.servicesList)---",this.state.servicesList);
			window.sessionStorage.setItem("serviceChecked", JSON.stringify(this.state.servicesList))
		})
	};

	stateSearchData = (stateData, city) => {
		if (stateData !== "" && city === "") {
			this.setState({
				searchAnything: "",
			});
			$("#state").attr("disabled", false);
		}
		this.setState(
			{
				stateValue: stateData,
				city: city,
			},
			() => {
				this.searchData();
				this.changeState(stateData);
				this.changeCity(city);
			}
		);
	};
	searchLocationData = (e) => {
		this.setState(
			{
				location: e,
			},
			() => {
				this.changeLocality(e);
				this.searchAnythingData(e);
				this.setState({ searchAnything: "" });
			}
		);
	};

	handlePageChange(pageNumber) {
		let offset = (parseInt(pageNumber - 1) * this.state.itemsCountPerPage).toString();
		let pagesize = this.state.pagesize;
		if (pageNumber == "1") {
			this.setState(
				{
					activePage: pageNumber,
					isLoading: "0",
					offset: offset,
					searchClickFlag: true,
				},
				() => this.getSearchResult(this.state.offset)
			);
		} else {
			this.setState(
				{
					activePage: pageNumber,
					offset: offset,
					searchClickFlag: true,
				},
				() => this.getSearchResult(this.state.offset)
			);
		}
		// window.sessionStorage.setItem("activePageCenters", this.state.activePage)
	}

	render() {
		return (
			<>
				<div className="container searchstore_top">
					<div className="row" id="search-section">
						<div className="col-lg-7 col-md-12 px-0 pe-lg-3 position-relative">
							<div className="error-msgs-text" id="SearchByGivenAddress">
								Please either enter your nearby locality or select your state first
							</div>
							<div className="search-store-form bg_white">
								<div className="row">
									<div className="col-md-12 position-relative">
										<input
											type="text"
											className="input-form-control"
											placeholder="Search nearby Branch or ATM"
											aria-label="Search nearby Branch or ATM"
											title="Search nearby Branch/ATM by locality, city e.g. Udyog Vihar, Gurgaon. Alternatively, start typing locality and select appropriate result from auto suggestion."
											id="searchAnything"
											value={this.state.searchAnything}
											onChange={(e) => this.searchByAnything(e.target.value)}
											></input>
										{
											// this.state.searchClickFlag === true ? (
											// 	<div className="search-input search-input-loader"></div>
											// ) : 
											this.state.searchAnything ? (
												<a
													href={"/?search=" + this.state.searchAnything.replaceAll(",", "%2C")}
  													onClick={() => sessionStorage.setItem("fromSearch", "true")}
													className="search-input"></a>
											) : (
												<a
													href={
														((this.state.stateValue && this.state.city) || this.state.stateValue) &&
														"/location/" +
														this.state.stateValue.replaceAll(" ", "-").toLowerCase() +
														"/" +
														this.state.city.replaceAll(" ", "-").toLowerCase()
													}
  													onClick={() => sessionStorage.setItem("fromSearch", "true")}
													className="search-input"></a>
											)}
									</div>
									<div className="add-or-div">
										<span>
											<img src={lineImg} alt="Search Branch" width="72" height="1" />
										</span>
										<span className="form-add-or">OR</span>
										<span>
											<img src={lineImg} alt="Search Branch" width="72" height="1" />
										</span>
									</div>
									<div className="col-md-6">
										<select
											//defaultValue={"Maharashtra"}
											value={this.state.stateValue}
											name="state"
											id="state"
											className="input-form-control"
											onChange={(e) => this.changeState(e.target.value)}
											title={
												this.state.stateOptionDefault == "All" || this.state.stateOptionDefault == "State"
													? "Please select state"
													: this.state.stateOptionDefault
											}>
											<option value="">{this.state.stateOptionDefault}</option>
											{this.state.stateList.map((data, i) => (
												<option key={i} value={data}>
													{data}
												</option>
											))}
										</select>
									</div>

									<div className="col-md-6">
										<select
											name="city"
											id="city"
											disabled={this.state.stateValue ? false : true}
											value={this.state.city}
											onChange={(e) => this.changeCity(e.target.value)}
											className="input-form-control"
											title={this.state.stateValue == "" ? "Please select state first" : this.state.cityTextDefault}>
											<option value="">{this.state.stateValue == "" ? "Please select state first" : this.state.cityTextDefault}</option>
											{this.state.cityList.map((data, i) => (
												<option key={i} value={data.city}>
													{data.city}
												</option>
											))}
										</select>
									</div>
									<div className="col-md-6">
										<input
											type="text"
											className="input-form-control"
											id="location"
											disabled
											value={this.state.location}
											onChange={(e) => this.changeLocality(e.target.value)}
											onKeyDown={(obj) => {
												obj.key == "Enter" && this.searchData();
											}}
											placeholder={this.state.locationTextDefault}
											title={this.state.locationTextDefault}
										/>
									</div>
									<div className="col-md-6">
										<select
											name="radius"
											id="radius"
											disabled
											value={this.state.radius}
											onChange={(e) =>
												this.setState({
													radius: e.target.value,
												})
											}
											className="input-form-control"
											title={this.state.radiusOptionDefault}>
											<option value={this.state.radiusOptionDefault}>{this.state.radiusOptionDefault}</option>
											{this.state.radiusList.map((data, i) => (
												<option key={i} value={data}>
													- {data} KM -
												</option>
											))}
										</select>
									</div>
									<div className="col-md-12 mb-3">
										<div className="sub-label-head">Category</div>
										<div className="col-md-12 p-0 pt-1">
											{this.state.categoryList.map((data, i) => {

												// let statusParsed = JSON.parse(window.sessionStorage?.getItem("categoryChecked")) || []
												// let status = statusParsed.length > 0 ? statusParsed.filter((ob) => ob.name === data.name)[0].status : data.status
												// console.log("statusParsed---", statusParsed.length > 0);
												return (
													<div className="checkbox-list" key={i}>
														<input
															id={"check" + data.name.replaceAll(" ", "")}
															type="checkbox"
															checked = {data.status}
															onChange={(e) => this.changeCategory(e, data.name)}
															onKeyDown={(obj) => {
																obj.key == "Enter" && this.searchData();
															}}></input>
														<label htmlFor={"check" + data.name.replaceAll(" ", "")}>{data.name}</label>
													</div>
												)
											})}
										</div>
									</div>
									<div className="col-md-12">
										<div className="sub-label-head">Services</div>
										<div className="col-md-12 p-0 pt-1">
											{this.state.servicesList.map((data, i) => (
												<div className="checkbox-list" key={i}>
													<input
														id={"check" + data.name.replaceAll(" ", "")}
														type="checkbox"
														//value={data.name}
														checked={data.status}
														onChange={(e) => this.changeService(e, data.name )}
														onKeyDown={(obj) => {
															obj.key == "Enter" && this.searchData();
														}}></input>
													<label htmlFor={"check" + data.name.replaceAll(" ", "")}>{data.name}</label>
												</div>
											))}
										</div>
									</div>

									<div className="col-md-12">
										{
											// this.state.searchClickFlag === true ? (
											// 	<button className="button-search" disabled={"disabled"}>
											// 		Loading <img className="ml-1" src={searchLoading} width="20" />
											// 	</button>
											// ) : 
											this.state.searchAnything ? (
												<a href={"/?search=" + this.state.searchAnything.replaceAll(",", "%2C")}
													onClick={() => sessionStorage.setItem("fromSearch", "true")} className="button-search">
													Search
												</a>
											) : (
												<a
													href={
														((this.state.stateValue && this.state.city) || this.state.stateValue) &&
														"/location/" +
														this.state.stateValue.replaceAll(" ", "-").toLowerCase() +
														"/" +
														this.state.city.replaceAll(" ", "-").toLowerCase()
													}
  													onClick={() => sessionStorage.setItem("fromSearch", "true")}
													className="button-search">
													Search
												</a>
											)}

										<button className="button-cancel" onClick={() => window.location.reload()}>
											Reset
										</button>
									</div>
								</div>
							</div>
						</div>
						{/* {this.state.searchFlag === true && this.state.centersTotalCount > 0 ? */}
						<>
							<div className="col-lg-5 col-md-12 google-map-main">
								<GoogleMap
									key={this.state.mapKey}
									// basicData= {data.data.dealerData}
									locationLatLongArray={this.state.centersData}
									isData={this.state.isData}
								/>
							</div>
						</>
						{/* :
              <div className="col-lg-5 col-md-12 no-outlet-msg-outer">
                <div className="no-outlet-msg">
                  <img src={noOutletImg} className="no-outlet-msgImg"></img>
                  <p className="no-stores"> No Branches/ATM's are available!! </p>
                </div>
              </div>} */}
					</div>
					{/* {this.state.searchFlag === true ? */}
					<div className="row">
						<Servicestation
							key={this.state.searchUpdateKey}
							centersData={this.state.centersData}
							centersTotalCount={this.state.centersTotalCount}
							offset={this.state.offset}
							pagesize={this.state.pagesize}
							activePage={this.state.activePage}
							itemsCountPerPage={this.state.itemsCountPerPage}
							// check={"iiiiiiiiiiiiiiiiiii"}
							dataPassing={[
								{ stateValueSet: this.state.stateValue },
								{ citySet: this.state.city },
								{ locationSet: this.state.location },
								{ radiusSet: this.state.radius },
								{ searchCategorySet: this.state.searchCategory },
								{ searchServiceSet: this.state.searchService },
								{ offsetSet: this.state.offset },
								{ activePageSet: this.state.activePage },
								{ searchValueSet: !this.state.searchAnything ? searchValueSet : this.state.searchAnything },
								{ currentLocationFlagSetValue: currentLocationFlag },
								{ locationList: this.state.locationList },
								{ stateList: this.state.stateList },
								{ cityList: this.state.cityList },
							]}
							handlePageChange={(pageNumber) => {
								this.handlePageChange(pageNumber);
							}}
						/>
					</div>
					{/* : ""
          } */}
				</div>

				<ImportantNotice />

				<div className="subfooter_home">
					<div className="footer_city_state">
						<div className="container p-0">
							<div className="footer_state_url">
								{/* {this.state.stateValue !== "" && */}
								<ul className="city_state_name_add">
									{this.state.stateValue !== "" && this.state.city !== "" ? (
										<li>Localities in</li>
									) : this.state.stateValue !== "" && this.state.city === "" ? (
										<li>Cities in</li>
									) : this.state.stateValue === "" && this.state.city === "" && this.state.searchAnything !== "" ? (
										<>
											<li>States : </li> <br />
										</>
									) : (
										""
									)}

									{this.state.stateValue !== "" && this.state.city !== "" ? (
										<>
											<li>
												<a onClick={() => this.stateSearchData(this.state.stateValue, "")} className="locality_active">
													{this.state.stateValue}
												</a>
											</li>
											{this.state.location ? (
												<>
													<li>
														{">> "}
														<span
															className="footer-location-list locality_active"
															onClick={() => this.stateSearchData(this.state.stateValue, this.state.city)}>
															{this.state.city}
														</span>
													</li>
													<li>
														{" "}
														{">> "}
														{this.state.location}
													</li>
												</>
											) : (
												<li>
													{" "}
													{">> "}
													{this.state.city}
												</li>
											)}{" "}
											<br />
											<li>
												<p id="locationFirstView" className="city_state_name_add_new">
													{this.state.locationList.length > 5 ? (
														<>
															{this.state.locationList.map((data, i) =>
																i < 5 ? (
																	<span className="footer-location-list" key={i} onClick={() => this.searchLocationData(data.location)}>
																		{" "}
																		{data.location} {"/"}{" "}
																	</span>
																) : (
																	""
																)
															)}
															<span
																className="read_more"
																onClick={() => {
																	$("#locationFullView").attr("hidden", false);
																	$("#locationFirstView").attr("hidden", true);
																}}>
																View More...
															</span>
														</>
													) : (
														<>
															{this.state.locationList.map((data, i) => (
																<span className="footer-location-list" key={i} onClick={() => this.searchLocationData(data.location)}>
																	{" "}
																	{data.location} {"/"}{" "}
																</span>
															))}
														</>
													)}
												</p>

												<p id="locationFullView" className="city_state_name_add_new" hidden>
													{this.state.locationList.map((data, i) => (
														<span className="footer-location-list" key={i} onClick={() => this.searchLocationData(data.location)}>
															{" "}
															{data.location} {"/"}{" "}
														</span>
													))}
													<p
														className="read_more"
														onClick={() => {
															$("#locationFullView").attr("hidden", true);
															$("#locationFirstView").attr("hidden", false);
														}}>
														View Less
													</p>
												</p>
											</li>
										</>
									) : this.state.stateValue !== "" && this.state.city === "" ? (
										<>
											<li>{this.state.stateValue}</li> <br />
											<li>
												<p id="cityFirstView" className="city_state_name_add_new">
													{this.state.cityList.length > 5 ? (
														<>
															{this.state.cityList.map((data, i) =>
																i < 5 ? (
																	<span
																		className="footer-location-list"
																		key={i}
																		onClick={() => this.stateSearchData(this.state.stateValue, data.city)}>
																		{" "}
																		{data.city} {"/"}{" "}
																	</span>
																) : (
																	""
																)
															)}
															<span
																className="read_more"
																onClick={() => {
																	$("#cityFullView").attr("hidden", false);
																	$("#cityFirstView").attr("hidden", true);
																}}>
																View More...
															</span>
														</>
													) : (
														<>
															{this.state.cityList.map((data, i) => (
																<span
																	className="footer-location-list"
																	key={i}
																	onClick={() => this.stateSearchData(this.state.stateValue, data.city)}>
																	{" "}
																	{data.city} {"/"}{" "}
																</span>
															))}
														</>
													)}
												</p>
												<p id="cityFullView" className="city_state_name_add_new" hidden>
													{this.state.cityList.map((data, i) => (
														<span className="footer-location-list" key={i} onClick={() => this.stateSearchData(this.state.stateValue, data.city)}>
															{" "}
															{data.city} {"/"}{" "}
														</span>
													))}
													<p
														className="read_more"
														onClick={() => {
															$("#cityFullView").attr("hidden", true);
															$("#cityFirstView").attr("hidden", false);
														}}>
														View Less
													</p>
												</p>
											</li>
										</>
									) : this.state.stateValue === "" && this.state.city === "" && this.state.searchAnything !== "" ? (
										<li>
											<p id="stateFirstView" className="city_state_name_add_new">
												{this.state.stateList.length > 5 ? (
													<>
														{this.state.stateList.map((data, i) =>
															i < 5 ? (
																<span className="footer-location-list" key={i} onClick={() => this.stateSearchData(data, "")}>
																	{" "}
																	{data} {"/"}{" "}
																</span>
															) : (
																""
															)
														)}
														<span
															className="read_more"
															onClick={() => {
																$("#stateFullView").attr("hidden", false);
																$("#stateFirstView").attr("hidden", true);
															}}>
															View More...
														</span>
													</>
												) : (
													<>
														{this.state.stateList.map((data, i) => (
															<span className="footer-location-list" key={i} onClick={() => this.stateSearchData(data, "")}>
																{" "}
																{data} {"/"}{" "}
															</span>
														))}
													</>
												)}
											</p>
											<p id="stateFullView" className="city_state_name_add_new" hidden>
												{this.state.stateList.map((data, i) => (
													<span className="footer-location-list" key={i} onClick={() => this.stateSearchData(data, "")}>
														{" "}
														{data} {"/"}{" "}
													</span>
												))}
												<p
													className="read_more"
													onClick={() => {
														$("#stateFullView").attr("hidden", true);
														$("#stateFirstView").attr("hidden", false);
													}}>
													View Less
												</p>
											</p>
										</li>
									) : (
										""
									)}
								</ul>
								{/* } */}
							</div>
						</div>
					</div>
				</div>
			</>
		);
	}
}
export default SearchStore;
